import { capSQLiteSet } from "@capacitor-community/sqlite";
import { CoreoFormGroup } from "../../../types";
import { AppDatabaseRepo } from "./base.db";

export interface AppDatabaseFormGroup {
  id: number;
  projectId: number;
  name: string;
  sort: number;
}

export class AppDatabaseFormGroupRepo extends AppDatabaseRepo<AppDatabaseFormGroup, AppDatabaseFormGroup, CoreoFormGroup> {

  columns = [
    ['id', 'INTEGER NOT NULL'],
    ['projectId', 'INTEGER NOT NULL'],
    ['name', 'TEXT NOT NULL'],
    ['sort', 'INTEGER'],
  ];

  indexes = [
    'CREATE INDEX IF NOT EXISTS idx_formGroups_projectId ON formGroups(projectId)'
  ];
  references = [];
  primaryKey = ["id", "projectId"];
  tableName = 'formGroups';

  public toInsertSet(group: AppDatabaseFormGroup): capSQLiteSet[] {
    const columns = this.columns.map(c => c[0]).join(',');
    const values = this.columns.map(() => '?').join(',');
    return [{
      statement: `INSERT OR REPLACE INTO ${this.tableName} (${columns}) VALUES (${values})`,
      values: [group.id, group.projectId, group.name, group.sort ?? 0]
    }];
  }

  async deserialise(group: AppDatabaseFormGroup): Promise<CoreoFormGroup> {
    return { id: group.id, name: group.name, sort: group.sort };
  }
}
